var React = require('react');

function House (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M406.987 421.684L87.9294 354.765L137.382 118.987L314.97 66.3435L456.439 185.906L406.987 421.684Z","fill":"#469BD4"}));
}

House.defaultProps = {"width":"0","height":"0","viewBox":"0 0 501 541","fill":"none","id":"house","className":"shape"};

module.exports = House;

House.default = House;
